import { StateStore } from "../../app/state/StateStore";
import { ScreenMapper } from "./ScreenMapper";
import type { KrokScreen } from "../../app/api/ApiClient";

export class KrokScreenMapper
    implements ScreenMapper<KrokScreen> {

    readonly type = "krok" as const;

    constructor(
        private readonly store: StateStore
    ) {}

    apply(screen: KrokScreen): void {

        const state = this.store.getState();

        this.store.replace({

            ...state,

            currentKrokId:
                screen.id,

            krok:
                screen,

            gaps:
                state.currentKrokId === screen.id
                    ? state.gaps
                    : {},

            revealed:
                state.currentKrokId === screen.id
                    ? state.revealed
                    : {},

            primaryScreen: {

                type: "core"

            },

            isLoading: false

        });

    }

}